import { SET_LOADING } from './actionTypes';
import { createAction, ActionsUnion } from '../../../helpers/createAction';

export const Actions = {
  setLoading: (payload: boolean) => createAction(SET_LOADING, payload),
};

export type ActionsTypes = ActionsUnion<typeof Actions>;
